import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AccordionEmissionService {
  private accordionOpenedSource = new Subject<void>()

  accordionOpened$ = this.accordionOpenedSource.asObservable()

  emitAccordionOpened() {
    this.accordionOpenedSource.next()
  }
}
